import axios from 'axios'
import router from '../../router'

const state = {
  token: localStorage.getItem('token') || null,
  user: JSON.parse(localStorage.getItem('user')) || null,
  signupEnabled: false
}

const getters = {
  isLoggedIn: state => !!state.token,
  currentUser: state => state.user,
  isSignupEnabled: state => state.signupEnabled
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER(state, user) {
    state.user = user
  },
  SET_SIGNUP_ENABLED(state, enabled) {
    state.signupEnabled = enabled
  },
  LOGOUT(state) {
    state.token = null
    state.user = null
  }
}

const actions = {
  // Check signup status
  async checkSignupStatus({ commit }) {
    try {
      const response = await axios.get('/api/auth/signup-status')
      const { signupEnabled } = response.data
      
      // Update state
      commit('SET_SIGNUP_ENABLED', signupEnabled)
      
      return signupEnabled
    } catch (error) {
      console.error('Error checking signup status:', error)
      commit('SET_SIGNUP_ENABLED', false)
      return false
    }
  },
  
  // Login user
  async login({ commit }, credentials) {
    try {
      const response = await axios.post('/api/auth/login', credentials)
      const { token, user } = response.data
      
      // Save auth data to localStorage
      localStorage.setItem('token', token)
      localStorage.setItem('user', JSON.stringify(user))
      
      // Set axios default auth header
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      
      // Update state
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
      
      return response
    } catch (error) {
      throw error
    }
  },
  
  // Register user
  async register({ commit }, userData) {
    try {
      const response = await axios.post('/api/auth/register', userData)
      return response
    } catch (error) {
      throw error
    }
  },
  
  // Logout user
  logout({ commit }) {
    // Remove auth data from localStorage
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    
    // Remove auth header
    delete axios.defaults.headers.common['Authorization']
    
    // Update state
    commit('LOGOUT')
    
    // Redirect to login
    router.push('/login')
  },
  
  // Initialize auth from localStorage (called on app start)
  async initAuth({ commit, dispatch }) {
    const token = localStorage.getItem('token')
    const user = localStorage.getItem('user')
    
    if (token) {
      // Set axios default auth header
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      // Restore auth state
      commit('SET_TOKEN', token)
      
      if (user) {
        commit('SET_USER', JSON.parse(user))
      }
    }
    
    // Check signup status
    await dispatch('checkSignupStatus')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}